import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Vehicle } from "../models/vehicle";
import { AuthService } from "../auth-n-routing/auth-service.service";
import { Travel } from "../models/travel";
import { DateHandlerService } from "../commons/date-handler.service";
import { BusyServices } from "../commons/busy.service";
import { TechnicalShutdown } from "../models/technical_shutdown";
import { Park } from "../models/park";
import { VehicleModel } from "../models/vehicle-model";
import { VehicleType } from "../models/vehicle-type";

@Injectable()
export class VehiclesHandlerService {
  private getByParkIDURI = "vehicles/getByParkID";
  private getByParkIDInDataRangeAvailableURI =
    "vehicles/getByParkIDInDataRangeAvailable";
  private getVehicleByPlateURI = "vehicles/getByPlate";
  private getVehicleByIdURI = "vehicles/getById";
  private getVehicleModelsURI = "vehicles/getModels";
  private getVehicleTypesURI = "vehicles/getTypes";
  private createVehicleURI = "vehicles/create";
  private userCanDriveVehiclesURI = "vehicles/userCanDriveVehicles";
  private techShutdownCreateOrEditURI = "technical_shutdown/createOrEdit";
  private techShutdownDeleteURI = "technical_shutdown/delete";
  private techShutdownGetByVehicleURI = "technical_shutdown/getByVehicle";
  private techShutdownGetByParkURI = "technical_shutdown/getByPark";
  private adminUpdateVehicleURI = "vehicles/adminUpdateVehicle";
  private getAllByParkIDURI = "vehicles/getAllByParkID";
  private getRawBrandsURI = "vehicles/getRawBrands";
  private adminCreateBrandURI = "vehicles/adminCreateBrand";
  private adminUpdateBrandURI = "vehicles/adminUpdateBrand";
  private getRawModelsURI = "vehicles/getRawModels";
  private adminCreateModelURI = "vehicles/adminCreateModel";
  private adminUpdateModelURI = "vehicles/adminUpdateModel";
  private adminGetDetailsByPlateURI = "vehicles/getDetailsByPlate?plate=";

  // Veicoli disponibili
  public dataVehiclesIcons = [
    { type: 1, descr: "NULL", icon: "fa-question-circle" },
    { type: 2, descr: "TRATTORE PER SEMIRIMORCHIO", icon: "fa-tractor" },
    { type: 3, descr: "TRATTORE STRADALE", icon: "fa-tractor" },
    { type: 4, descr: "AUTOCARRO", icon: "fa-truck" },
    { type: 5, descr: "NULL", icon: "fa-question-circle" },
    { type: 6, descr: "NULL", icon: "fa-question-circle" },
    { type: 7, descr: "NULL", icon: "fa-question-circle" },
    { type: 8, descr: "NULL", icon: "fa-question-circle" },
    { type: 9, descr: "VETTURA", icon: "fa-car-side" },
    { type: 10, descr: "AUTOBUS", icon: "fa-bus-alt" },
    { type: 11, descr: "NULL", icon: "fa-question-circle" },
    { type: 12, descr: "NULL", icon: "fa-question-circle" },
    { type: 13, descr: "NULL", icon: "fa-question-circle" },
    { type: 14, descr: "NULL", icon: "fa-question-circle" },
    { type: 15, descr: "OPERATRICE SEMOVENTE", icon: "fa-truck-loading" },
    { type: 16, descr: "NULL", icon: "fa-question-circle" },
    { type: 17, descr: "NULL", icon: "fa-question-circle" },
    { type: 18, descr: "NULL", icon: "fa-question-circle" },
    { type: 19, descr: "CICLOMOTORE", icon: "fa-motorcycle" },
    { type: 20, descr: "NULL", icon: "fa-question-circle" },
    { type: 21, descr: "RIMORCHIO", icon: "fa-truck-loading" },
    { type: 22, descr: "GRUPPO ELETTROGENO", icon: "fa-charging-station" },
    { type: 23, descr: "RIMORCHIO", icon: "fa-truck-loading" },
    { type: 24, descr: "CAMPER", icon: "fa-bus" },
    { type: 25, descr: "NULL", icon: "fa-question-circle" },
    { type: 26, descr: "NULL", icon: "fa-question-circle" },
    { type: 27, descr: "NULL", icon: "fa-question-circle" },
    { type: 28, descr: "NULL", icon: "fa-question-circle" },
    { type: 29, descr: "NULL", icon: "fa-question-circle" },
    { type: 30, descr: "NULL", icon: "fa-question-circle" },
    { type: 31, descr: "NULL", icon: "fa-question-circle" },
    { type: 32, descr: "CARRELLO ELEVATORE", icon: "fa-luggage-cart" },
    { type: 33, descr: "NULL", icon: "fa-question-circle" },
    { type: 34, descr: "MOTOCICLO", icon: "fa-motorcycle" },
    { type: 35, descr: "AUTOAMBULANZA", icon: "fa-ambulance" },
    { type: 36, descr: "NULL", icon: "fa-question-circle" },
    { type: 37, descr: "MINIBUS", icon: "fa-shuttle-van" },
    { type: 38, descr: "NULL", icon: "fa-question-circle" },
    { type: 39, descr: "NULL", icon: "fa-question-circle" },
    { type: 40, descr: "NULL", icon: "fa-question-circle" },
    { type: 41, descr: "NULL", icon: "fa-question-circle" },
    { type: 42, descr: "PULMINO", icon: "fa-shuttle-van" },
    { type: 43, descr: "NULL", icon: "fa-question-circle" },
    { type: 44, descr: "NULL", icon: "fa-question-circle" },
    { type: 45, descr: "NULL", icon: "fa-question-circle" },
    { type: 46, descr: "NULL", icon: "fa-question-circle" },
    { type: 47, descr: "AUTOFURGONE", icon: "fa-truck" },
    { type: 48, descr: "NULL", icon: "fa-question-circle" },
    { type: 49, descr: "NULL", icon: "fa-question-circle" },
    { type: 50, descr: "NULL", icon: "fa-question-circle" },
    { type: 51, descr: "NULL", icon: "fa-question-circle" },
    { type: 52, descr: "NULL", icon: "fa-question-circle" },
    { type: 53, descr: "AUTOCARAVAN", icon: "fa-bus" },
    { type: 54, descr: "NULL", icon: "fa-question-circle" },
    { type: 55, descr: "NULL", icon: "fa-question-circle" },
    { type: 56, descr: "NULL", icon: "fa-question-circle" },
    { type: 57, descr: "NULL", icon: "fa-question-circle" },
    { type: 58, descr: "NULL", icon: "fa-question-circle" },
    { type: 59, descr: "NULL", icon: "fa-question-circle" },
    { type: 60, descr: "QUADRICICLO", icon: "fa-truck-monster" },
    { type: 61, descr: "MOTOSLITTA", icon: "fa-sleigh" },
    { type: 62, descr: "SEMIRIMORCHIO", icon: "fa-truck-loading" },
    { type: 63, descr: "SCONOSCIUTO", icon: "fa-question-circle" },
    { type: 64, descr: "CAMION", icon: "fa-truck" },
    { type: 65, descr: "TRATTORE AGRICOLO", icon: "fa-tractor" },
  ];

  constructor(
    private busy: BusyServices,
    private http: HttpClient,
    private authService: AuthService,
    private dateHandlerService: DateHandlerService
  ) {}

  getByParkID(park_id: string): Promise<Vehicle[]> {
    return new Promise<Vehicle[]>((resolve, reject) => {
      const _http = this.http
        .post(
          environment.api.baseUrl + this.getByParkIDURI,
          { park_id: park_id },
          environment.api.config
        )
        .subscribe((data: any) => {
          const toRet = [];
          if (data.data) {
            data.data.forEach(function (vehicle_server_obj) {
              const v = new Vehicle(vehicle_server_obj["vehicle"]);
              v["utlimi_chilometri"] = parseFloat(
                vehicle_server_obj["vehicle"]["utlimi_chilometri"]
              );
              v["chilometri_litro"] =
                parseFloat(vehicle_server_obj["vehicle"]["chilometri_totali"]) /
                (parseFloat(vehicle_server_obj["vehicle"]["litri_totali"]) -
                  parseFloat(vehicle_server_obj["vehicle"]["last_litri"]));
              v["refused"] = vehicle_server_obj["vehicle"]["refused"];
              v["refused_total"] =
                vehicle_server_obj["vehicle"]["refused_total"];
              v["approved"] = vehicle_server_obj["vehicle"]["approved"];
              v["approved_total"] =
                vehicle_server_obj["vehicle"]["approved_total"];
              v["pending"] = vehicle_server_obj["vehicle"]["pending"];
              v["pending_total"] =
                vehicle_server_obj["vehicle"]["pending_total"];
              v["last_fuel_level"] =
                vehicle_server_obj["vehicle"]["last_fuel_level"];

              if (vehicle_server_obj["vehicle"]["is_away_until"]) {
                v["is_away_until"] = new Date(
                  vehicle_server_obj["vehicle"]["is_away_until"].replace(
                    /-/g,
                    "/"
                  )
                );
              } else {
                v["is_away_until"] = null;
              }

              v["is_away"] = !!v["is_away_until"];
              v["travels"] = vehicle_server_obj["vehicle"]["travels"];

              if (vehicle_server_obj["vehicle"]["ultimo_viaggio"]) {
                v["ultimo_viaggio"] = new Date(
                  vehicle_server_obj["vehicle"]["ultimo_viaggio"].replace(
                    /-/g,
                    "/"
                  )
                );
              } else {
                v["ultimo_viaggio"] = null;
              }

              toRet.push(v);
            });
          }

          resolve(toRet);
        });
      this.busy.setBusy(_http);
    });
  }

  getAllByParkID(park_id: string): Promise<Vehicle[]> {
    return new Promise<Vehicle[]>((resolve, reject) => {
      const _http = this.http
        .post(
          environment.api.baseUrl + this.getAllByParkIDURI,
          { park_id: park_id },
          environment.api.config
        )
        .subscribe((data: any) => {
          const toRet = [];
          if (data.data) {
            data.data.forEach(function (vehicle_server_obj) {
              const v = new Vehicle(vehicle_server_obj["vehicle"]);
              v["utlimi_chilometri"] = parseFloat(
                vehicle_server_obj["vehicle"]["utlimi_chilometri"]
              );
              v["chilometri_litro"] =
                parseFloat(vehicle_server_obj["vehicle"]["chilometri_totali"]) /
                (parseFloat(vehicle_server_obj["vehicle"]["litri_totali"]) -
                  parseFloat(vehicle_server_obj["vehicle"]["last_litri"]));
              v["refused"] = vehicle_server_obj["vehicle"]["refused"];
              v["refused_total"] =
                vehicle_server_obj["vehicle"]["refused_total"];
              v["approved"] = vehicle_server_obj["vehicle"]["approved"];
              v["approved_total"] =
                vehicle_server_obj["vehicle"]["approved_total"];
              v["pending"] = vehicle_server_obj["vehicle"]["pending"];
              v["pending_total"] =
                vehicle_server_obj["vehicle"]["pending_total"];
              v["last_fuel_level"] =
                vehicle_server_obj["vehicle"]["last_fuel_level"];
              v["closed_at"] = vehicle_server_obj["vehicle"]["vhc_closed_at"];

              if (vehicle_server_obj["vehicle"]["is_away_until"]) {
                v["is_away_until"] = new Date(
                  vehicle_server_obj["vehicle"]["is_away_until"].replace(
                    /-/g,
                    "/"
                  )
                );
              } else {
                v["is_away_until"] = null;
              }

              v["is_away"] = !!v["is_away_until"];
              v["travels"] = vehicle_server_obj["vehicle"]["travels"];

              if (vehicle_server_obj["vehicle"]["ultimo_viaggio"]) {
                v["ultimo_viaggio"] = new Date(
                  vehicle_server_obj["vehicle"]["ultimo_viaggio"].replace(
                    /-/g,
                    "/"
                  )
                );
              } else {
                v["ultimo_viaggio"] = null;
              }

              toRet.push(v);
            });
          }

          resolve(toRet);
        });
      this.busy.setBusy(_http);
    });
  }

  getByParkIDInDataRangeAvailable(
    park_id: string,
    date_from: Date,
    date_to: Date
  ): Promise<Vehicle[]> {
    return new Promise<Vehicle[]>((resolve, reject) => {
      const _http = this.http
        .post(
          environment.api.baseUrl + this.getByParkIDInDataRangeAvailableURI,
          {
            park_id: park_id,
            date_from: date_from,
            date_to: date_to,
          },
          environment.api.config
        )
        .subscribe((data: any) => {
          const toRet = [];
          if (data.data) {
            data.data.forEach(function (vehicle_server_obj) {
              const v = new Vehicle(vehicle_server_obj["vehicle"]);

              v["tech_shutdown_vehicle"] =
                vehicle_server_obj["vehicle"]["tech_shutdown_vehicle"];
              v["approved_travel_vehicle"] =
                vehicle_server_obj["vehicle"]["approved_travel_vehicle"];

              toRet.push(v);
            });
          }

          resolve(toRet);
        });
      this.busy.setBusy(_http);
    });
  }

  getVehicleByPlate(travel: Travel, plate: string): Promise<Vehicle[]> {
    return new Promise<Vehicle[]>((resolve, reject) => {
      const body = {
        plate: plate,
        admin_id: this.authService.getAuthenticatedUser().id.toString(),
        from: this.dateHandlerService.formatDate(travel.required_from),
        to: this.dateHandlerService.formatDate(travel.required_to),
      };

      const _http = this.http
        .post(
          environment.api.baseUrl + this.getVehicleByPlateURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          const vehicles = [];
          data.data.forEach((v) => {
            if (v.vehicle) {
              vehicles.push(new Vehicle(v.vehicle));
            } else {
              vehicles.push(new Vehicle(undefined));
            }
          });
          resolve(vehicles);
        });
      this.busy.setBusy(_http);
    });
  }
  getVehicleById(id: string): Promise<Vehicle> {
    return new Promise<Vehicle>((resolve, reject) => {
      const body = {
        id: id,
        admin_id: this.authService.getAuthenticatedUser().id.toString(),
      };

      const _http = this.http
        .post(
          environment.api.baseUrl + this.getVehicleByIdURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          resolve(data);
        });
      this.busy.setBusy(_http);
    });
  }

  getModels(model: string, brand: string): Promise<VehicleModel[]> {
    return new Promise<VehicleModel[]>((resolve, reject) => {
      const body = { model, brand };

      const _http = this.http
        .post(
          environment.api.baseUrl + this.getVehicleModelsURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          const toRet = [];
          if (data.data) {
            data.data.forEach(function (vehicleModelsObj) {
              toRet.push(new VehicleModel(vehicleModelsObj["vehicleModels"]));
            });
          }

          resolve(toRet);
        });
      this.busy.setBusy(_http);
    });
  }

  getClasses(classe: string, sottoclasse: string): Promise<VehicleType[]> {
    return new Promise<VehicleType[]>((resolve, reject) => {
      const body = { class: classe, subclass: sottoclasse };

      const _http = this.http
        .post(
          environment.api.baseUrl + this.getVehicleTypesURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          const toRet = [];
          if (data.data) {
            data.data.forEach(function (vehicleTypesObj) {
              toRet.push(new VehicleType(vehicleTypesObj["vehicleTypes"]));
            });
          }

          resolve(toRet);
        });
      this.busy.setBusy(_http);
    });
  }

  createTechnicalShutdown(
    technical_shutdown: TechnicalShutdown
  ): Promise<TechnicalShutdown> {
    return new Promise<TechnicalShutdown>((resolve, reject) => {
      const body = {
        from: this.dateHandlerService.formatDate(technical_shutdown._from),
        to: this.dateHandlerService.formatDate(technical_shutdown.to),
        vehicle_id: "" + technical_shutdown.vehicle_id,
        motivation: technical_shutdown.motivation
          ? technical_shutdown.motivation
          : "",
      };
      const _http = this.http
        .post(
          environment.api.baseUrl + this.techShutdownCreateOrEditURI,
          body,
          environment.api.config
        )
        .subscribe(
          (data: any) => {
            resolve(new TechnicalShutdown(data["technical_shutdown"]));
          },
          (err) => {
            alert(err.error);
          }
        );
      this.busy.setBusy(_http);
    });
  }

  editTechnicalShutdown(
    technical_shutdown: TechnicalShutdown
  ): Promise<TechnicalShutdown> {
    return new Promise<TechnicalShutdown>((resolve, reject) => {
      const body = {
        id: technical_shutdown.id,
        from: this.dateHandlerService.formatDate(technical_shutdown._from),
        to: this.dateHandlerService.formatDate(technical_shutdown.to),
        vehicle_id: "" + technical_shutdown.vehicle_id,
        motivation: technical_shutdown.motivation
          ? technical_shutdown.motivation
          : "",
      };
      const _http = this.http
        .post(
          environment.api.baseUrl + this.techShutdownCreateOrEditURI,
          body,
          environment.api.config
        )
        .subscribe(
          (data: any) => {
            resolve(new TechnicalShutdown(data["technical_shutdown"]));
          },
          (err) => {
            alert(err.error);
          }
        );
      this.busy.setBusy(_http);
    });
  }

  deleteTechnicalShutdown(
    technical_shutdown: TechnicalShutdown
  ): Promise<true> {
    return new Promise<true>((resolve, reject) => {
      const body = {
        id: technical_shutdown.id,
      };
      const _http = this.http
        .post(
          environment.api.baseUrl + this.techShutdownDeleteURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          resolve(true);
        });
      this.busy.setBusy(_http);
    });
  }

  getTechnicalShutdown(
    vehicle: Vehicle,
    only_future: boolean
  ): Promise<TechnicalShutdown[]> {
    return new Promise<TechnicalShutdown[]>((resolve, reject) => {
      const body = {
        vehicle_id: vehicle.id,
        only_future: only_future ? "1" : "0",
      };
      const _http = this.http
        .post(
          environment.api.baseUrl + this.techShutdownGetByVehicleURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          const toRet = [];
          if (data.data) {
            data.data.forEach(function (tech_shut_server_obj) {
              console.log(tech_shut_server_obj);
              toRet.push(
                new TechnicalShutdown(
                  tech_shut_server_obj["technical_shutdown"]
                )
              );
            });
          }

          resolve(toRet);
        });
      this.busy.setBusy(_http);
    });
  }

  downloadTagliando(plate: string): Promise<Blob> {
    return new Promise<Blob>((resolve, reject) => {
      this.authService.getTokenFromAM().then((token: any) => {
        const environment_tagliando = {
          api: {
            config: {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "",
              },
            },
          },
        };
        const configs_tagliando = environment_tagliando.api.config;
        configs_tagliando.headers["Content-Type"] = "application/octet-stream";
        configs_tagliando.headers["Authorization"] =
          token.token_type + " " + token.access_token;
        configs_tagliando["responseType"] = "blob";

        const _http = this.http
          .get(
            `${environment.api.apimanagerUrl}public/cri/motorizzazione/rca/veicolo/` +
              plate +
              "/tagliando",
            environment_tagliando.api.config
          )
          .subscribe((data: any) => {
            resolve(data);
          });
        this.busy.setBusy(_http);
      });
    });
  }

  checkCartaCircolazione (plate: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.authService.getTokenFromAM().then((token: any) => {
        const environment_circolazione = {
          api: {
            config: {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "",
              },
            },
          },
        };

        const configs_circolazione = environment_circolazione.api.config;
        configs_circolazione.headers["Content-Type"] = "application/octet-stream";
        configs_circolazione.headers["Authorization"] = token.token_type + " " + token.access_token;

        const _http = this.http
          .get(
            `${environment.api.apimanagerUrl}public/cri/motorizzazione/cartadigitale/${plate}/stato`, environment_circolazione.api.config
          )
          .subscribe((data: any) => {
            resolve(data);
          });
        this.busy.setBusy(_http);
      });
    });
  }

  downloadCartaCircolazione (plate: string): Promise<Blob> {
    return new Promise<Blob>((resolve, reject) => {
      this.authService.getTokenFromAM().then((token: any) => {
        const environment_circolazione = {
          api: {
            config: {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "",
              },
            },
          },
        };

        const configs_circolazione = environment_circolazione.api.config;
        configs_circolazione.headers["Content-Type"] = "application/octet-stream";
        configs_circolazione.headers["Authorization"] = token.token_type + " " + token.access_token;
        configs_circolazione["responseType"] = "blob";

        const _http = this.http
          .get(
            `${environment.api.apimanagerUrl}public/cri/motorizzazione/cartadigitale/${plate}/doc`, environment_circolazione.api.config
          )
          .subscribe((data: any) => {
            resolve(data);
          });
        this.busy.setBusy(_http);
      });
    });
  }

  getTechnicalShutdownByPark(
    park: Park,
    only_future: boolean
  ): Promise<TechnicalShutdown[]> {
    return new Promise<TechnicalShutdown[]>((resolve, reject) => {
      const body = {
        park_id: park.id,
        only_future: only_future ? "1" : "0",
      };
      const _http = this.http
        .post(
          environment.api.baseUrl + this.techShutdownGetByParkURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          const toRet = [];
          if (data.data) {
            data.data.forEach(function (tech_shut_server_obj) {
              toRet.push(
                new TechnicalShutdown(
                  tech_shut_server_obj["technical_shutdown"]
                )
              );
            });
          }

          resolve(toRet);
        });
      this.busy.setBusy(_http);
    });
  }

  getVehicleUserCanDrive(): Promise<Vehicle[]> {
    return new Promise<Vehicle[]>((resolve, reject) => {
      const body = {
        user_id: this.authService.getAuthenticatedUser().id.toString(),
      };

      const _http = this.http
        .post(
          environment.api.baseUrl + this.userCanDriveVehiclesURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          const toRet = [];
          if (data.data) {
            data.data.forEach(function (vehicle_server_obj) {
              toRet.push(new Vehicle(vehicle_server_obj["vehicle"]));
            });
          }

          resolve(toRet);
        });
      this.busy.setBusy(_http);
    });
  }

  create(
    plate: string,
    model_id: number,
    type_id: number,
    park_id: number
  ): Promise<Vehicle> {
    return new Promise<Vehicle>((resolve, reject) => {
      const body = { plate, model_id, type_id, park_id };

      const _http = this.http
        .post(
          environment.api.baseUrl + this.createVehicleURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.vehicle) {
            resolve(new Vehicle(data.vehicle));
          } else {
            reject();
          }
        });
      this.busy.setBusy(_http);
    });
  }

  adminUpdateVehicle(body: Object): Promise<Object> {
    return new Promise<Object>((resolve, reject) => {
      const _http = this.http
        .post(
          environment.api.baseUrl + this.adminUpdateVehicleURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.vehicle) {
            resolve(new Vehicle(data.vehicle));
          } else {
            reject();
          }
        });
      this.busy.setBusy(_http);
    });
  }

  getRawBrands(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const _http = this.http
        .get(
          environment.api.baseUrl + this.getRawBrandsURI,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.data) {
            resolve(data.data);
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }

  adminCreateBrand(body: Object): Promise<Object> {
    return new Promise<Object>((resolve, reject) => {
      const _http = this.http
        .post(
          environment.api.baseUrl + this.adminCreateBrandURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.vehicle) {
            resolve(new Vehicle(data.vehicle));
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }

  adminUpdateBrand(body: Object): Promise<Object> {
    return new Promise<Object>((resolve, reject) => {
      const _http = this.http
        .put(
          environment.api.baseUrl + this.adminUpdateBrandURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.vehicle) {
            resolve(new Vehicle(data.vehicle));
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }

  getRawModels(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const _http = this.http
        .get(
          environment.api.baseUrl + this.getRawModelsURI,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.data) {
            resolve(data.data);
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }

  adminCreateModel(body: Object): Promise<Object> {
    return new Promise<Object>((resolve, reject) => {
      const _http = this.http
        .post(
          environment.api.baseUrl + this.adminCreateModelURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.vehicle) {
            resolve(new Vehicle(data.vehicle));
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }

  adminUpdateModel(body: Object): Promise<Object> {
    return new Promise<Object>((resolve, reject) => {
      const _http = this.http
        .put(
          environment.api.baseUrl + this.adminUpdateModelURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.vehicle) {
            resolve(new Vehicle(data.vehicle));
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }

  getDetailsByPlate(plate: string): Promise<Vehicle> {
    return new Promise<Vehicle>((resolve, reject) => {
      const _http = this.http
        .get(
          environment.api.baseUrl + this.adminGetDetailsByPlateURI + plate,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.data.length !== 0) {
            resolve(new Vehicle(data.data[0].vehicle));
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }
}
